import { css } from 'styled-components';

const camelToKebab = str => str.replace(/[A-Z]/g, letter => `-${letter.toLowerCase()}`);

const custom = (obj = {}) => css`
  ${Object.entries(obj)
    .map(([key, value]) => `${camelToKebab(key)}: ${value};`)
    .join('\n')}
`;

export { custom };
